module.exports = __webpack_public_path__ + "img/logo_阿里.390d6a05.png";